import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../layout/LayoutContainer'
import { CRITERIA } from './constant'
import classes from './index.module.scss'
import {
  changeAnalyse,
  changeVersus,
  selectAnalyse,
  selectVersus,
} from './store/slice'

export const AnalyseVersus = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const analyse = useSelector(selectAnalyse)
  const versus = useSelector(selectVersus)

  const handleSelectAnalyse = ({ value }) => {
    dispatch(changeAnalyse(value))
    if (value === versus) {
      dispatch(
        changeVersus(
          versus === CRITERIA.CREDIT_RISK_SCORE.value
            ? CRITERIA.PERFORMANCE_SCORE.value
            : CRITERIA.CREDIT_RISK_SCORE.value,
        ),
      )
    }
  }

  const handleSelectVersus = ({ value }) => {
    dispatch(changeVersus(value))
    if (value === analyse) {
      dispatch(
        changeAnalyse(
          analyse === CRITERIA.CREDIT_RISK_SCORE.value
            ? CRITERIA.PERFORMANCE_SCORE.value
            : CRITERIA.CREDIT_RISK_SCORE.value,
        ),
      )
    }
  }

  return (
    <div className={classes.analyseVersus}>
      <div className={classes.item}>
        <Element className="fw600" style={{ color: '#3A414B' }}>
          <Translate value="portfolio.summary.ANALYSE" />:
        </Element>
        <SelectCustom
          key={locale}
          data={Object.values(CRITERIA)}
          activeItem={{ value: analyse }}
          chooseItem={handleSelectAnalyse}
          isI18n
          isBorderNone
          iconWhenShowDropList="icon-arrow-bottom"
          iconWhenHiddenDropList="icon-arrow-bottom"
          iconNoPosition
          style={{ padding: 0, alignItems: 'baseline' }}
          styleDropdown={{ whiteSpace: 'nowrap' }}
          scrollElementIds={[SCROLL_LAYOUT_ELEMENT_ID]}
        />
      </div>
      <div className={classes.item}>
        <Element className="fw600" style={{ color: '#3A414B' }}>
          <Translate value="portfolio.summary.VERSUS" />:
        </Element>
        <SelectCustom
          key={locale}
          data={Object.values(CRITERIA)}
          activeItem={{ value: versus }}
          chooseItem={handleSelectVersus}
          isI18n
          isBorderNone
          iconWhenShowDropList="icon-arrow-bottom"
          iconWhenHiddenDropList="icon-arrow-bottom"
          iconNoPosition
          style={{ padding: 0, alignItems: 'baseline' }}
          styleDropdown={{ whiteSpace: 'nowrap' }}
          scrollElementIds={[SCROLL_LAYOUT_ELEMENT_ID]}
        />
      </div>
    </div>
  )
}
